import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";

import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, EMPTY, Observable, Subscription } from "rxjs";

import { catchError, finalize, map, tap } from "rxjs/operators";
import {
  CurrentAccountDTO,
  CurrentAccountMovementExtendedDTO,
} from "src/app/models/current-accounts/CurrentAccountDTO";

import { SnackbarType } from "src/app/models/snackbar/snackbar.model";
import { CurrentAccountsService } from "src/app/shared/services/current-accounts/current-accounts.service";
import { SnackBarUtils } from "src/app/shared/utils/snackbarUtils";
import { setSnackbar } from "src/app/store/actions/messages/message.actions";
import { AppState } from "src/app/store/reducers";

@Component({
  selector: "current-accounts-by-party-list",
  templateUrl: "./current-accounts-by-party-list.component.html",
  styleUrls: ["./current-accounts-by-party-list.component.scss"],
})
export class CurrentAccountsByPartyList implements OnInit, OnDestroy {
  public _token: string;

  @Input() set token(token: string) {
    if (token) {
      this._token = token;
    }
  }

  public isLoading$ = new BehaviorSubject<boolean>(false);
  public currentAccount: CurrentAccountDTO;
  public excelCurrentAccountsByPartyList$: Observable<CurrentAccountMovementExtendedDTO[]>;
  public totalCurrentAccountsByPartyList$ = new BehaviorSubject<number>(0);
  private getCurrentAccountsByPartyListSub: Subscription;

  constructor(
    private store: Store<AppState>,
    private currentAccountsService: CurrentAccountsService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.getCurrentAccountsByPartyList();
  }

  getCurrentAccountsByPartyList() {
    this.isLoading$.next(true);

    this.getCurrentAccountsByPartyListSub = this.currentAccountsService
      .getCurrentAccountsByParty(this._token)
      .pipe(
        map((result) => {
          const [currAcc] = result;
          return currAcc;
        }),
        catchError((error) => {
          this.store.dispatch(
            setSnackbar(
              SnackBarUtils.setSnackBar(
                this.translate.instant("CurrentAccounts.currentAccountsLoadError"),
                SnackbarType.ERROR
              )
            )
          );
          return EMPTY;
        }),
        finalize(() => this.isLoading$.next(false))
      )
      .subscribe((result: CurrentAccountDTO) => {
        this.currentAccount = result;
      });
  }

  ngOnDestroy(): void {
    if (this.getCurrentAccountsByPartyListSub) {
      this.getCurrentAccountsByPartyListSub.unsubscribe();
    }
  }
}
